import type { Filter_FacetsFragment } from '@generated/graphql'

export const renameFilteredFacetsLabel = (
  filteredFacets?: Filter_FacetsFragment[]
) => {
  const listLabels: { [key: string]: string } = {
    price: 'Faixa de preço',
    'category-4': 'Tipo de produto',
    sugestao: 'Público',
  }

  return filteredFacets?.map((item) => ({
    ...item,
    label: listLabels?.[item?.key] || item?.label,
  }))
}
